var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.646 5.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1-.708.708L8 6.707l-3.646 3.647a.5.5 0 0 1-.708-.708z",
    clipRule: "evenodd"
  })));
};
export { SvgUp as ReactComponent };
export default __webpack_public_path__ + "2d480bfbe74870bf3fad1460dfbaabfb.svg";